import { render } from "./BtnExcluir.vue?vue&type=template&id=32d3570a"
import script from "./BtnExcluir.vue?vue&type=script&lang=js"
export * from "./BtnExcluir.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__